<template lang="pug">
  v-container
    h1.black--text.text-center Edit Profile
    v-row
      v-col(cols=6)
        v-card
          v-card-title Profile
          v-card-text
            text-field(label="Name" label-width=110 value="John Doe")
            text-field(label="Email Address" label-width=110 value="jdoe@arlingtonva.us")
      v-col(cols=6)
        v-card(outlined)
          v-card-title Teams
          v-card-text
            v-card
              v-card-text
                text-field(label="School" label-width=110 value="Abingdon ES")
                text-field(label="Grade" label-width=110 value="4th")
                text-field(label="Role" label-width=110 value="Head Coach")
</template>

<script>
import TextField from "@/components/TextField"

export default {
  components: {
    TextField
  }
}
</script>